import { Box, CircularProgress } from "@mui/material";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../../components/Header";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import InventoryForm from "../../../components/FormInventory";
import { useTranslation } from "react-i18next";

const UpdateInventory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [inventoryItem, setInventoryItem] = useState(null);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const apiUrl = "https://oven-backend.onrender.com";

  useEffect(() => {
    const fetchInventoryItem = async () => {
      try {
        const response = await axios.get(`${apiUrl}/inventory/${id}`);
        console.log("✅ بيانات العنصر:", response.data);
        setInventoryItem(response.data);
      } catch (error) {
        console.error("❌ خطأ في جلب العنصر:", error);
        setError(t("error_fetching_item"));
      } finally {
        setLoading(false);
      }
    };
    fetchInventoryItem();
  }, [id, t]);

  const handleFormSubmit = async (values) => {
    setUpdating(true);
    setError(null);

    try {
      const formattedValues = {
        ...values,
        totalQuantity: Number(values.totalQuantity),
        minStockLevel: Number(values.minStockLevel),
        unitPrice: Number(values.unitPrice),
        lastPurchaseDate: new Date(values.lastPurchaseDate).toISOString(),
        supplier: values.supplier || null,
      };

      console.log("✅ إرسال طلب التحديث مع:", formattedValues);
      await axios.patch(`${apiUrl}/inventory/${id}`, formattedValues);
      console.log("✅ تم تحديث المخزون بنجاح");
      setOpen(true);
      setTimeout(() => {
        navigate("/inventory");
      }, 1000);
    } catch (error) {
      console.error("❌ خطأ في تحديث المخزون:", error.response?.data || error);
      setError(t("error_updating_item"));
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!inventoryItem) {
    return <Alert severity="error">{t("item_not_found")}</Alert>;
  }

  const initialValues = {
    itemName: inventoryItem.itemName || "",
    totalQuantity: inventoryItem.totalQuantity?.toString() || "",
    minStockLevel: inventoryItem.minStockLevel?.toString() || "",
    supplier: inventoryItem.supplier?._id || "",
    lastPurchaseDate: inventoryItem.lastPurchaseDate?.split("T")[0] || "",
    unitPrice: inventoryItem.unitPrice?.toString() || "",
  };
  console.log("✅ القيم الأولية الممررة إلى InventoryForm:", initialValues);

  return (
    <Box m="20px" sx={{ direction: isRTL ? "rtl" : "ltr" }}>
      <Header title={t("update_inventory_item")} subtitle={t("modify_inventory_details")} />
      <InventoryForm
        initialValues={initialValues}
        handleFormSubmit={handleFormSubmit}
        buttonLabel={updating ? <CircularProgress size={24} color="inherit" /> : t("update_item")}
        disabled={updating}
      />
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%", fontFamily: isRTL ? "Cairo, sans-serif" : "Roboto, sans-serif" }}
        >
          {t("inventory_updated_successfully")}
        </Alert>
      </Snackbar>
      <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError(null)}>
        <Alert
          onClose={() => setError(null)}
          severity="error"
          variant="filled"
          sx={{ width: "100%", fontFamily: isRTL ? "Cairo, sans-serif" : "Roboto, sans-serif" }}
        >
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UpdateInventory;